import React from "react";
import { Row, Col } from "react-bootstrap";
import "./dashboard.css";
import {
  AddLinkBox,
  AddCertificateBox,
  BulkUploadCErtificate,
  UploadMember,
  BUlkUploadMembers,
  UserDEtails,
  TransactionDet,
} from "../../../assets/images";

import DashboardCertificateAvailable from "./dashboard-certifiicate-available";
import CertificateReportsGraph from "./CertificateReportsGraph";
import MostSendCertificate from "./MostSendCertificate";

const AfterLoginDashboard = () => {
  return (
    <div className="right_cont">
      <div className="right_banner_banner_cnt">
        <div className="travel_deals_admin">
          <h2>Hello, Admin!</h2>

          <div className="mt-5">
            <Row>
              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="/add-link" className="banner_box">
                    <img src={AddLinkBox} className="img-fluid" alt="" />
                    <div className="banner_overlay">Add Link</div>
                  </a>
                </div>
              </Col>

              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="add-certificate" className="banner_box">
                    <img src={AddCertificateBox} className="img-fluid" alt="" />
                    <div className="banner_overlay">Upload Certificate</div>
                  </a>
                </div>
              </Col>
              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="/bulk-upload" className="banner_box">
                    <img
                      src={BulkUploadCErtificate}
                      className="img-fluid"
                      alt=""
                    />
                    <div className="banner_overlay">
                      Bulk Upload Certificates
                    </div>
                  </a>
                </div>
              </Col>

              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="/add-member" className="banner_box">
                    <img src={UploadMember} className="img-fluid" alt="" />
                    <div className="banner_overlay">Upload Member</div>
                  </a>
                </div>
              </Col>

              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="/bulk-upload-member" className="banner_box">
                    <img src={BUlkUploadMembers} className="img-fluid" alt="" />
                    <div className="banner_overlay">Bulk Upload Members</div>
                  </a>
                </div>
              </Col>

              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="/user-details" className="banner_box">
                    <img src={UserDEtails} className="img-fluid" alt="" />
                    <div className="banner_overlay">User Details</div>
                  </a>
                </div>
              </Col>
              <Col lg="3" md="6" sm="12" className="right_innrBanner">
                <div className="right_inner_inner_banner">
                  <a href="/transaction-details" className="banner_box">
                    <img src={TransactionDet} className="img-fluid" alt="" />
                    <div className="banner_overlay">Transaction Details</div>
                  </a>
                </div>
              </Col>
            </Row>
            <DashboardCertificateAvailable />

            <CertificateReportsGraph />
            <MostSendCertificate />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AfterLoginDashboard;
